import { render, staticRenderFns } from "./PopDocVisitorList.vue?vue&type=template&id=412a2b10&scoped=true"
import script from "./PopDocVisitorList.vue?vue&type=script&lang=js"
export * from "./PopDocVisitorList.vue?vue&type=script&lang=js"
import style0 from "./PopDocVisitorList.vue?vue&type=style&index=0&id=412a2b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a2b10",
  null
  
)

export default component.exports